// src/store.js
import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers";
import rootSaga from "./sagas";

// Persist config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["theme", "auth", "ui"], // Only persist these reducers
};

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store with saga middleware
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

// Run saga
sagaMiddleware.run(rootSaga);

// Persistor
export const persistor = persistStore(store);

export default store;
